import { render } from "./BaseFilePreview.vue?vue&type=template&id=08bf6009"
import script from "./BaseFilePreview.vue?vue&type=script&lang=js"
export * from "./BaseFilePreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/components/BaseFilePreview/BaseFilePreview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08bf6009"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08bf6009', __exports__)) {
    api.reload('08bf6009', __exports__)
  }
  
  module.hot.accept("./BaseFilePreview.vue?vue&type=template&id=08bf6009", () => {
    api.rerender('08bf6009', render)
  })

}


export default __exports__